import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { PrimaryButton } from '../../../modals/form-element.modal';

@Component({
  selector: 'primary-btn',
  templateUrl: './primary-btn.component.html',
  styleUrls: ['./primary-btn.component.css']
})
export class PrimaryBtnComponent implements OnInit {
  @Input() className = '';
  @Input() labelName = '';
  @Input() idName = '';
  @Input() type = '';
  @Input() hasPressEnter: Boolean = false;

  @Output() inputFocusEvent = new EventEmitter();
  @Output() inputClickEvent = new EventEmitter();
  @Output() inputBlurEvent = new EventEmitter();

  @Input() primaryButtonSetting: PrimaryButton;

  constructor() {}

  ngOnInit() {}

  onFocusEvent(event) {
    this.inputFocusEvent.emit(event);
  }

  onClickEvent() {
    this.inputClickEvent.emit({
      submitted: true
    });
  }

  onBlurEvent($event) {
    this.inputBlurEvent.emit($event);
  }
}
